module.exports = __webpack_public_path__ + "img/sushiLogo.9cd2f6c4.svg";